import { render, staticRenderFns } from "./loading-came.vue?vue&type=template&id=ea7c0836"
import script from "./loading-came.vue?vue&type=script&lang=js"
export * from "./loading-came.vue?vue&type=script&lang=js"
import style0 from "./loading-came.vue?vue&type=style&index=0&id=ea7c0836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports